import { Box, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Condition from "../condition/Condition";
import { useToast } from "../../context/toast/ToastContext";
import ProductWithQuantity, {
  useGenerateProductWithQuantity,
  ProductWithQuantityResult,
} from "./productWithQuantity/ProductWithQuantity";
import TableFC, { TableFCBodyProps, TableHeadProps } from "../table/Table";
import { useGetProducts } from "../../features/produk/api/product/resolver";
import { useGetInvoiceConstant } from "../../features/invoice/api/invoice/constant/resolver";

export interface ProductWithPriceInvoiceData {
  id: string;
  quantity: number;
  name: string;
  unitType: string;
  price: number;
  checked?: boolean;
  returQuantity?: number;
}

interface ProductWithPriceInvoice {
  invoiceType?: string;
  dataProduct?: ProductWithPriceInvoiceData[];
  showCheckBox?: boolean;
  header: TableHeadProps[];
  body: TableFCBodyProps[];
  lastRowRender: React.ReactElement[];
  onChange(item: any[]): void;
  setValue?(index: number, objectKey: string, value: any): void;
}

export default function ProductWithPriceInvoice({
  invoiceType,
  dataProduct,
  onChange,
  body,
  header,
  showCheckBox,
  lastRowRender,
}: ProductWithPriceInvoice) {
  const { show } = useToast();
  const { data: dataRawProduct } = useGetProducts({});
  const dataPro = dataRawProduct?.data.data.data;
  const { data: dataProductOptions } = useGenerateProductWithQuantity({
    dataSource: dataPro,
    keyForText: "product_type_name",
    keyForValue: "id",
    keyForStock: "stock",
  });
  const { data: dataRawInvoiceConstant } = useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data.type;
  const [cart, setCart] = useState<ProductWithPriceInvoiceData[]>([]);

  useEffect(() => {
    if (dataProduct) {
      setCart(
        dataProduct.map((item) => {
          return {
            id: item.id,
            name: item.name,
            price: item.price,
            quantity: item.quantity,
            unitType: item.unitType,
          };
        })
      );
    }
  }, [dataProduct]);

  useEffect(() => {
    const productList: any[] = [];
    cart.forEach((item) => {
      productList.push({
        product_id: item.id,
        quantity: item.quantity,
        price: item.price,
        checked: item.checked,
      });
    });
    onChange(productList);
  }, [cart]);

  const handleAddCart = (item: ProductWithQuantityResult) => {
    if (cart.find((itemCart) => itemCart.id === item.value)) {
      show("Produk ini sudah ada", "warning");
      return;
    }
    const isGrosir = dataInvoiceConstant?.Grosir === invoiceType;
    setCart([
      ...cart,
      {
        id: item.value,
        name: item.text,
        price: isGrosir ? item.ext.wholesale_price : item.ext.price,
        quantity: item.quantity,
        unitType: item.ext.unit_type,
      },
    ]);
  };

  const handleCheckedChange = (target: any[]) => {
    setCart((prev) => {
      return prev.map((item, indexCart) => {
        item.checked = false;
        if (target.find((itemTarget) => itemTarget.index === indexCart)) {
          item.checked = true;
        }
        return item;
      });
    });
  };

  useEffect(() => {}, [cart]);

  return (
    <React.Fragment>
      <Condition.IF condition={!dataProduct || dataProduct?.length <= 0}>
        <ProductWithQuantity
          options={dataProductOptions}
          onChange={(e) => handleAddCart(e)}
          onKeyUp={(e) => {}}
        />
      </Condition.IF>
      <Box mt={3}>
        <Condition.IF condition={cart.length > 0}>
          <TableFC
            showCheckBox={showCheckBox}
            showIndex
            data={cart}
            body={body}
            head={header}
            lastRowRender={lastRowRender}
            onChecked={(e) => handleCheckedChange(e)}
          />
        </Condition.IF>
      </Box>
    </React.Fragment>
  );
}
